import React from 'react';
import { SxProps } from '@mui/system';
import strings from '../../../../localization';
import ServiceCard from '../../ServiceCard/ServiceCard';
import BookingRequestsContent from './BookingRequestsContent';

export interface IBookingRequests {
  profileImage: Array<string | null>;
  onClick?: () => void;
  requestedCount?: number;
  customContainerStyle?: SxProps;
  hideTitle?: boolean;
}

const BookingRequests: React.FC<IBookingRequests> = ({
  profileImage,
  onClick,
  customContainerStyle,
  hideTitle,
  requestedCount = 0,
}) =>
  (
    <ServiceCard
      customContainerStyle={customContainerStyle}
      onClick={onClick}
      title={hideTitle ? null : strings.bookingRequests}
      content={(
        <BookingRequestsContent
          profileImage={profileImage}
          requestedCount={requestedCount}
          onClick={onClick}
        />
    )}
    />
  );

export default BookingRequests;
